import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IconBrandSuperhuman } from '@tabler/icons-react';
import { Alert, Row } from 'antd';
import { CrudSchemaField, type EnsoFormItem } from '@ohpen/enso-ui';

import { FieldType } from '@pmp/api';
import { exclusivesRedirectPath } from '@pmp/utils';

import { TabProps } from '../interfaces';
import { TabContent } from './TabContent';
import { CrudFormCard } from './CrudFormCard';

export const ExclusivesTab: React.FC<TabProps> = ({ form, mode, selectsOptions }) => {
  const { t } = useTranslation();

  const columns: EnsoFormItem[] = useMemo(
    () => [
      {
        title: t('lender.firms.labels.exclusiveProductSets'),
        dataIndex: ['exclusives'],
        valueType: 'select',
        readonlyDisplay: { type: 'tagsWithLink', getPath: exclusivesRedirectPath },
        fieldProps: {
          mode: 'multiple',
          options: selectsOptions[FieldType.EXCLUSIVITY_SETS],
        },
        colProps: { span: 12 },
        tooltip: t('lender.firms.labels.exclusiveProductSetsTooltip'),
      },
    ],
    [selectsOptions, t],
  );

  return (
    <TabContent>
      <Alert message={t('lender.firms.labels.exclusivesAlert')} type="info" showIcon />
      <CrudFormCard icon={<IconBrandSuperhuman />} title={t('lender.firms.labels.exclusives')}>
        <Row gutter={0}>
          {columns.map((item, i) => (
            <CrudSchemaField key={String(item.dataIndex ?? i)} item={item} form={form} readonly={true} />
          ))}
        </Row>
      </CrudFormCard>
    </TabContent>
  );
};
